import { RoomConfig, Rooms } from '../types';

/**
 * Partner specific ids
 */
export const defaultRoomConfig: RoomConfig = {
  roomName: Rooms.DEFAULT,
};
